export default "__VITE_ASSET__DcFyKqAY__"